export const GAME_IDS = {
    FWW: 'fww',
    FF: 'ff',
    FWW2E: 'fww2e'
};

export const GAME_ROLE_RESTRICTIONS: Record<string, string> = {
    [GAME_IDS.FWW2E]: 'app_admin'
};
